import React from 'react';
import Header from "../components/Header";
import Nextheader from "../components/Nextheader";
import HeroSection from "../components/HeroSection";
import Middle from "../components/Middle";
import CrimeTile from "../components/CrimeTile";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div>
      <Header />
      <Nextheader />
      <HeroSection />
      <CrimeTile />
      <Middle />
      <Footer />
    </div>
  );
};

export default Home;